import * as React from 'react'
import { IconButton } from '@mui/material'
import { MaterialReactTable } from 'material-react-table'
import { logOut } from 'ionicons/icons'
import { IonIcon } from '@ionic/react'

import { AuthContext } from '../../../contexts/authContext'

import { useOneShopUsers } from '../utils'
import { Card, CardContent } from '../../../components/ui/card'

import type { MRT_ColumnDef } from 'material-react-table'

import type { OneShopUser } from '../oneshop-user.schema'

const columns: Array<MRT_ColumnDef<OneShopUser>> = [
  {
    accessorKey: 'account.companyName',
    header: 'Company Name',
  },
  {
    accessorKey: 'firstName',
    header: 'First Name',
  },
  {
    accessorKey: 'lastName',
    header: 'Last Name',
  },
  {
    accessorKey: 'objectId',
    header: 'User ID',
  },
  {
    accessorKey: 'account.objectId',
    header: 'Account ID',
  },
]

function OneShopUsersTable() {
  const { handleSwitchAccount } = React.useContext(AuthContext)

  const { data, isError, isPending, isPreviousData, totalCount } =
    useOneShopUsers()

  if (isError) {
    return (
      <Card>
        <CardContent>Something went wrong loading the users.</CardContent>
      </Card>
    )
  }

  return (
    <div className="ion-padding">
      <Card>
        <CardContent>
          <MaterialReactTable
            columns={columns}
            data={data ?? []}
            enableToolbarInternalActions={false}
            enableRowActions={true}
            initialState={{
              showGlobalFilter: true,
              density: 'compact',
              pagination: { pageIndex: 0, pageSize: 5 },
            }}
            rowCount={totalCount}
            renderRowActions={({ row }) => (
              <>
                <IconButton
                  className="text-slate-500"
                  disabled={isPending}
                  onClick={() => handleSwitchAccount(row.original.username)}
                >
                  <IonIcon icon={logOut} />
                </IconButton>
              </>
            )}
            state={{
              isLoading: isPending,
              showProgressBars: isPending || isPreviousData,
            }}
          />
        </CardContent>
      </Card>
    </div>
  )
}

export { OneShopUsersTable }
